export type RubricaUtilizacaoFolhaPagamento = 'UTILIZADA' | 'NAO_UTILIZADA';

export type RubricaUtilizacaoFolhaPagamentoNome = 'Utilizada' | 'Não utilizada';

export const RUBRICA_UTILIZACAO_FOLHA_PAGAMENTO_NOMES: Record<
  RubricaUtilizacaoFolhaPagamento,
  RubricaUtilizacaoFolhaPagamentoNome
> = {
  UTILIZADA: 'Utilizada',
  NAO_UTILIZADA: 'Não utilizada',
};
